import { Icon } from "@blueprintjs/core"
import { Marker } from "@react-google-maps/api"
import Toggle from "components/Atoms/Toggle"
import CustomInfoWindow from "components/Organisms/map/CustomInfoWindow"
import { useToggleUserStatusMutation } from "graphql/user/user.hooks"
import { debounce } from "lodash-es"
import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
const VendorMarker = ({ vendor, position, clusterer }) => {
  const [mutate, { loading }] = useToggleUserStatusMutation(vendor?.id)

  const [isOpen, setOpen] = useState(false)
  const navigate = useNavigate()
  const handleMouseOut = debounce(() => setOpen(false), 1200)

  return (
    <>
      <Marker
        clusterer={clusterer}
        onMouseOver={e => {
          setOpen(true)
        }}
        onMouseOut={handleMouseOut}
        icon={{
          url:
            vendor.status === "AV"
              ? "http://maps.google.com/mapfiles/ms/icons/green-dot.png"
              : "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
        }}
        title={vendor?.fullName}
        onClick={e => {
          navigate(`/d/registration/vendors/details/${vendor?.id}`)
        }}
        key={vendor?.id}
        position={position}
      />
      {isOpen && (
        <CustomInfoWindow
          position={position}
          onCloseClick={e => setOpen(false)}
        >
          <div>
            <div className="flex">
              <Icon icon="user" className="mr-2" />{" "}
              <div>
                <div>{vendor?.fullName}</div>
                <div className="vt-muted text-sm">{vendor?.number}</div>
              </div>
            </div>

            <div className="flex mt-3">
              <Icon icon="map" className="mr-2" />{" "}
              <div className="text-xs">
                {vendor?.address?.address?.split(",")?.map((l, idx) => {
                  return (
                    <p className="my-0" key={idx}>
                      {l}
                    </p>
                  )
                })}
              </div>
            </div>
            <div className="flex mt-3">
              <Icon icon="ban-circle" className="mr-2" />{" "}
              <div className="vt-vendor-status">
                <Toggle
                  disabled={loading}
                  onChange={() => {
                    if (!loading) mutate()
                  }}
                  checked={vendor?.status === "AV"}
                  innerLabelChecked="AV"
                  innerLabel="NA"
                />
              </div>
            </div>
          </div>
        </CustomInfoWindow>
      )}
    </>
  )
}

export default VendorMarker
